import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { ParticipationCertificateModel } from '../model/participationCertificate';
var m = {
  namespaced: true,
  state: function state() {
    return {
      activityList: {
        list: [],
        loaded: false,
        req: false
      },
      activityMap: {},
      activityDetailMap: {},
      activityCertificates: {}
    };
  },
  mutations: {
    concatActivityList: function concatActivityList(state, _a) {
      var key = _a.key,
          list = _a.list;
      var ids = [];
      (list || []).forEach(function (item) {
        Vue.set(state.activityMap, item.activity_id, new ParticipationCertificateModel(item));
        ids.push(item.activity_id);
      });
      state.activityList.list = state.activityList.list.concat(ids);
    },
    setActivityListLoaded: function setActivityListLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.activityList.loaded = loaded;
    },
    setActivityListReq: function setActivityListReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.activityList.req = req;
    },
    setActivityCertificates: function setActivityCertificates(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.activityCertificates, activityId, data);
    },
    setActivityCertificateDetail: function setActivityCertificateDetail(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.activityDetailMap, activityId, new ParticipationCertificateModel(data));
    }
  },
  actions: {
    /**
     * 获取活动列表
     */
    getActivityList: function getActivityList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              wrap = state.activityList;

              if (wrap.req || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setActivityListReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation_certificates/activity_list', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatActivityList', {
                  list: list
                });

                if (list.length < count) {
                  commit('setActivityListLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setActivityListReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getActivityCertificates: function getActivityCertificates(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation_certificates/list', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityCertificates', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 获取活动详情 */
    getActivityCertificatesDetail: function getActivityCertificatesDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation_certificates/activity_detail', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityCertificateDetail', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 重新生成证书
     */
    regenerate: function regenerate(_a, _b) {
      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      var activityId = _b.activityId,
          name = _b.name;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation_certificates/regenerate', {
                activity_id: activityId,
                name: name
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;